import { NzPopoverDirective } from "ng-zorro-antd/popover";
import { ComponentFactoryResolver, Directive, ElementRef, EventEmitter, Host, Input, Optional, Output, Renderer2, ViewContainerRef } from "@angular/core";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";
import { NzConfigService } from "ng-zorro-antd/core/config";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NgStyleInterface, NzTSType } from "ng-zorro-antd/core/types";
import { NzTooltipTrigger } from "ng-zorro-antd/tooltip";

@Directive({
  selector: "[ui-popover]",
  exportAs: "uiPopover",
  host: {
    "[class.ant-popover-open]": "visible",
  },
})
export class UiPopoverDirective extends NzPopoverDirective {
  @Input("popoverArrowPointAtCenter")
  @InputBoolean()
  arrowPointAtCenter?: boolean;
  @Input("popoverTitle")
  title?: NzTSType;
  @Input("popoverContent")
  content?: NzTSType;
  @Input("ui-popover")
  directiveTitle?: NzTSType | null;
  @Input("popoverTrigger")
  trigger?: NzTooltipTrigger = "hover";
  @Input("popoverPlacement")
  placement?: string | string[] = "top";
  @Input("popoverOrigin")
  origin?: ElementRef<HTMLElement>;
  @Input("popoverVisible")
  visible?: boolean;
  @Input("popoverMouseEnterDelay")
  mouseEnterDelay?: number;
  @Input("popoverMouseLeaveDelay")
  mouseLeaveDelay?: number;
  @Input("popoverOverlayClassName")
  overlayClassName?: string;
  @Input("popoverOverlayStyle")
  overlayStyle?: NgStyleInterface;

  @Output("popoverVisibleChange") readonly visibleChange = new EventEmitter<boolean>();

  constructor(
    elementRef: ElementRef,
    hostView: ViewContainerRef,
    resolver: ComponentFactoryResolver,
    renderer: Renderer2,
    @Host() @Optional() public noAnimation?: NzNoAnimationDirective,
    nzConfigService?: NzConfigService
  ) {
    super(elementRef, hostView, resolver, renderer, noAnimation, nzConfigService);
  }
}
